
    import React from 'react'
    import Base from '@ucheba/ui/components/Icon'
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js"
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js"

    const symbol = new SpriteSymbol({
  "id": "icon__star-filled",
  "use": "icon__star-filled-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon__star-filled\"><path fill=\"currentColor\" d=\"M8.974 1.125 8.457 2.35 6.681 6.567l-5.556.604 4.156 3.92L4.1 16.875l4.874-2.966 4.87 2.966-1.178-5.784 4.152-3.92-5.552-.604z\" fill-rule=\"evenodd\" /></symbol>"
})
    sprite.add(symbol)

    export default React.memo(function IconStarFilledIcon(props) {
      const { className, ...restProps } = props
      return <Base.Icon className={className} id="icon__star-filled" {...restProps} />
    })
  